module.exports = __webpack_public_path__ + "static/media/1004400.7a531ed0.jpg";